<script>
import LimitedComponentsList from 'frontend/common/limited-components-list.vue'
import { User } from 'frontend/users'
import { uniqBy } from 'lodash'

export default {
  name: 'ShiftJobCreatedBy',
  props: {
    item: { type: Object },
  },
  setup() {
    return {
      User,
    }
  },
  computed: {
    uniqTbsCreatedBy() {
      const tbs = (this.item.transportBookings || []).filter(
        tb => !!tb.createdBy && tb.createdBy?.id != this.item.createdBy?.id,
      )
      if (tbs?.length) {
        return uniqBy(
          tbs.map(el => el.createdBy),
          'id',
        )
      } else {
        return []
      }
    },
  },
  components: {
    User,
    LimitedComponentsList,
  },
}
</script>

<template lang="pug">
div(v-if="item.createdBy")
  user(:user="item.createdBy")
div(v-if="uniqTbsCreatedBy.length")
  limited-components-list(
    :component="User"
    :component-props="item => ({ user: item })"
    :items="uniqTbsCreatedBy"
    :limit="5"
    main-class="tb-created-by"
  )
</template>
